import api from "../../../services/axiosConfig";
import createModuleApi from "../../../services/createModuleApi";

const roleMapping = {
  User: "ROLE_USER",
  Admin: "ROLE_ADMIN",
  "Super User": "ROLE_SUPERUSER",
};

const crud = createModuleApi("/instances/skeye/skeyeform", {
  endpoints: { list: "/users" },
  unwrap: (res) => res.data.data.users.users,
});

export const fetchUsers = crud.fetchAll;

export const deleteUser = async (id) => {
  const res = await api.delete(`/instances/skeye/skeyeform/users/${id}`);
  return res.data;
};

/* export const updateUser = async (id, data) => {
  const res = await api.put(`/instances/skeye/skeyeform/users/${id}`, data);
  return res.data;
}; */

export const createUser = async (userData) => {
  const res = await api.post("/instances/skeye/skeyeform/users/add", {
    username: userData.username,
    email: userData.email,
    password: userData.password,
    roles: [roleMapping[userData.role] || "USER"],
  });
  return res.data;
};

export const updateUserRole = async (userId, newRoleLabel, oldRoleLabel) => {
  const newRole = roleMapping[newRoleLabel];
  const oldRole = oldRoleLabel ? roleMapping[oldRoleLabel] : null;
  if (!newRole) throw new Error("New role is required");
  if (oldRole)
    await api.delete(`/instances/skeye/skeyeform/users/${userId}/roles`, {
      params: { role: oldRole },
    });
  const res = await api.put(
    `/instances/skeye/skeyeform/users/${userId}/roles`,
    {},
    { params: { role: newRole } },
  );
  return res.data;
};
